<body class="body-form-signin login-bg">
  <main class="form-register">
    <form class="form-shadow p-4" [formGroup]="resetPasswordForm" autocomplete="off" novalidate (ngSubmit)="resetPassword(resetPasswordForm.value)">
      <div class="container justify-content-center">
        <div class="row justify-content-center">

          <app-message [service]="messageService"></app-message>

          <div class="text-center  pb-3">
            <a href="https://cubos.com" target="_blank"><img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72" height="57"></a>
            <div class="col-12 mb-2">
              <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@ForgotPasswordHeader">Neues Passwort setzen.</h3>
              <h4 class="mt-md-2 ml-md-0 ms-2 text-center" i18n="@@ForgotPasswordLabel">
                Hier können Sie ein neues Passwort für Ihr Konto vergeben.
              </h4>
            </div>
          </div>
        </div>

        <div class="row justify-content-center round">
          <div class="col-lg-10 col-md-12">
            <div class="form-group row">
              <label for="password" class="col-form-label col-sm-4" i18n="@@ChoosePasswordLabel">Passwort vergeben*</label>
              <div class="col-md-8">
                <input type="password" id="password" formControlName="password" class="form-control" />
                <div class="error">
                  <em *ngIf="validateControl('password') && hasError('password', 'required')" i18n="@@PasswordRequiredError">Passwort wird benötigt</em>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="confirm" class="col-form-label col-sm-4" i18n="@@ConfirmPasswordLabel">Passwort wiederholen*</label>
              <div class="col-md-8">
                <input type="password" id="confirm" formControlName="confirm" class="form-control" />
                <div class="error">
                  <em *ngIf="validateControl('confirm') && hasError('confirm', 'required')" i18n="@@ConfirmPasswordError">Bestätigung des Passworts ist erforderlich</em>
                  <em *ngIf="hasError('confirm', 'mustMatch')" i18n="@@PasswordsNotIdenticError">Passwörter müssen übereinstimmen</em>
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="mb-1 text-center">
                <button type="submit" id="changepassword" class="btn btn-yellow px-3" [disabled]="!resetPasswordForm.valid" i18n="@@ChangePasswordButton">Passwort ändern</button>
              </div>
              <p class="mt-2 mb-3 text-center text-muted"> © {{currentYearLong()}} CUBOS Service GmbH</p>
            </div>
          </div>
        </div>
        <small i18n="@@MandatoryInputHint">mit * gekennzeichnete Felder sind Pflichtfelder</small>
      </div>
    </form>
  </main>
</body>

<ng-template #successMessage i18n="@@ChangePasswordSuccessMessage">
  Ihr Passwort wurde zurückgesetzt. Bitte <a [routerLink]="['/auth/login']" id="backtologin">klicken Sie hier, um sich einzuloggen.</a>
</ng-template>
